module.exports = __webpack_public_path__ + "static/media/banner-group.0fb0b5d1.png";